import { faGears } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { AppSettings } from '~/components/molecules/AppSettings';
import { Heading } from '~/components/molecules/Heading';

export type IAppSettingsPageProps = {
  appId: string;
};

export const AppSettingsPage: React.FC<IAppSettingsPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppSettingsPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faGears} />}
        title={t('AppSettingsPage.title')}
        subtitle={t('AppSettingsPage.subtitle')}
      />

      <AppSettings appId={appId} />
    </>
  );
};
